/** @format */

import React, { useEffect, useState } from "react";
import { CompanyTitledPage } from "../../TitledPage";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  OutlinedInput,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import DateInput from "../../../components/DateInput";
import { getHyphenedDate } from "../../../utils/utils";
import SelectBox from "../../../components/SelectBox";
import { NormalTable } from "../../../components/TableCustomize";
import { totalTransferColumn, transferColumn } from "./enhance";
import { getVar } from "../../../http/api/VarAPI";
import { getBanks, getBranchBanks } from "../../../http/api/BankAPI";
import { getListTransferConfirmation } from "../../../http/api/PaymentAPI";

const TransferSearchArea = ({
  onSearchCondition,
  searchConditionInput,
  changeSearchConditionInput,
}) => {
  const { jaSelection } = searchConditionInput;

  const [jaSelections, setJaSelections] = useState([]);
  const [jaBranchSelections, setJaBranchSelections] = useState([]);

  const onFocusInput = event => {
    event.target.select();
  };

  const handleChangeSearchCondition = e => {
    changeSearchConditionInput(e);
  };

  const onClickSearch = event => {
    onSearchCondition();
  };

  const getBankList = async () => {
    const result = await getBanks();
    if (result.data) {
      setJaSelections(
        result.data.map(b => {
          return { key: b.bankCd, value: b.bankName };
        })
      );
    }
  };

  const getBranchBankList = async () => {
    const result = await getBranchBanks({ bankCd: jaSelection });
    if (result.data) {
      const newBank = result.data.map(b => {
        return { key: b.bankBranchCd, value: b.bankBranchName };
      });
      setJaBranchSelections(newBank);
    }
  };

  useEffect(() => {
    getBankList();
  }, []);

  useEffect(() => {
    if (jaSelection !== "-1") {
      getBranchBankList();
    }
  }, [jaSelection]);

  return (
    <Box border='1px solid blue' borderRadius={1} padding={2}>
      検索
      <Box margin={2}>
        <Grid container alignItems='end' spacing={2}>
          <Grid item xs>
            <Stack
              direction='row'
              alignItems='center'
              flexWrap='wrap'
              justifyContent={{ xl: "space-between", lg: "left" }}>
              <Stack
                direction='row'
                alignItems='center'
                flexWrap='wrap'
                justifyContent={{ sm: "space-between", md: "left" }}
                width={{ md: "auto", sm: 380 }}
                marginBottom={{ xl: 0, xs: 2 }}>
                <Typography>荷主(No/氏名):&nbsp;</Typography>
                <OutlinedInput
                  onFocus={onFocusInput}
                  onChange={({ target: { value } }) =>
                    handleChangeSearchCondition({ keyword: value })
                  }
                  value={searchConditionInput.keyword}
                  sx={{ width: 250 }}
                />
              </Stack>
            </Stack>
            <Stack
              direction='row'
              alignItems='center'
              flexWrap='wrap'
              marginTop={2}>
              <Stack direction='row' alignItems='center'>
                <Checkbox
                  checked={searchConditionInput.jaSelection !== "-1"}
                  onChange={(_e, v) => {
                    if (v) {
                      handleChangeSearchCondition({
                        jaSelection: jaSelections[0]?.key || "-1",
                      });
                    } else {
                      handleChangeSearchCondition({
                        jaSelection: "-1",
                        jaBranchSelection: "-1",
                      });
                    }
                  }}
                />
                <Typography>農協で絞る</Typography>
                <Stack>
                  <SelectBox
                    data={jaSelections}
                    value={searchConditionInput.jaSelection}
                    onChange={({ target: { value } }) =>
                      handleChangeSearchCondition({
                        jaSelection: value,
                        jaBranchSelection: "-1",
                      })
                    }
                    sx={{ width: 180 }}
                    disabled={searchConditionInput.jaSelection === "-1"}
                  />
                </Stack>
              </Stack>
              <Stack direction='row' alignItems='center'>
                <Checkbox
                  checked={
                    searchConditionInput.jaBranchSelection !== "-1" &&
                    searchConditionInput.jaSelection !== "-1"
                  }
                  disabled={searchConditionInput.jaSelection === "-1"}
                  onChange={(_e, v) => {
                    if (v) {
                      handleChangeSearchCondition({
                        jaBranchSelection: jaBranchSelections[0]?.key || "-1",
                      });
                    } else {
                      handleChangeSearchCondition({ jaBranchSelection: "-1" });
                    }
                  }}
                />
                <Typography>支所で絞る</Typography>
                <Stack>
                  <SelectBox
                    data={jaBranchSelections}
                    value={searchConditionInput.jaBranchSelection}
                    onChange={({ target: { value } }) =>
                      handleChangeSearchCondition({ jaBranchSelection: value })
                    }
                    sx={{ width: 180 }}
                    disabled={searchConditionInput.jaBranchSelection === "-1"}
                  />
                </Stack>
              </Stack>
              <Stack direction='row' alignItems='center'>
                <Checkbox
                  checked={searchConditionInput.existsPayment}
                  onChange={(_e, v) => {
                    handleChangeSearchCondition({ existsPayment: v });
                  }}
                />
                <Typography>支払ありで絞る</Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs='auto'>
            <Button variant='contained' onClick={onClickSearch}>
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default function TransferConfirmation() {
  const [shippingDateInput, setShippingDateInput] = useState(
    getHyphenedDate(new Date())
  );
  const [regionBank, setRegionBank] = useState([]);
  const [searchConditionInput, setSearchConditionInput] = useState({
    keyword: "",
    jaSelection: "-1",
    jaBranchSelection: "-1",
    existsPayment: false,
  });
  const [tableTabPosition, setTableTabPosition] = useState(null);
  const [totalTransferData, setTotalTransferData] = useState([]);
  const [transferData, setTransferData] = useState([]);

  const updateShippingDate = shippingDate => {
    setShippingDateInput(shippingDate);
  };

  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 30,
    totalPage: 1,
  });

  const onSearchCondition = () => {
    getTransferDataBank({ page: 0 });
  };

  const changeSearchConditionInput = e => {
    setSearchConditionInput({
      ...searchConditionInput,
      ...e,
    });
  };

  const handleChangePageProps = page => {
    setPagination({ ...pagination, page });
  };

  const getRegionBank = async () => {
    const results = await getVar({ varDiv: 25 });
    if (results.listVarInfo) {
      setRegionBank(results.listVarInfo);
    }
  };

  const getTransferDataBank = async (params = {}) => {
    const param = {
      date: shippingDateInput,
      ...searchConditionInput,
      region: tableTabPosition,
      page: pagination.page,
      size: pagination.pageSize,
      ...params,
    };

    const result = await getListTransferConfirmation(param);
    if (result.data) {
      const {
        totalData,
        results: { items, page, pageSize, totalPage },
      } = result.data;
      setTotalTransferData(totalData);
      setTransferData(items);
      setPagination({ ...pagination, page, pageSize, totalPage });
    }
  };

  useEffect(() => {
    if (regionBank.length > 0) {
      setTableTabPosition(regionBank[0].varCd);
    }
  }, [regionBank]);

  useEffect(() => {
    getTransferDataBank({ page: 0 });
  }, [tableTabPosition, shippingDateInput]);

  useEffect(() => {
    getRegionBank();
    getTransferDataBank();
  }, []);

  return (
    <CompanyTitledPage title='振込一覧表確認' hideCurrentTime>
      <Grid
        container
        spacing={2}
        alignItems='center'
        justifyContent='flex-end'
        marginBottom={2}>
        <Grid item xs>
          <Typography sx={{ fontSize: 20, textAlign: "right" }}>
            日付 :
          </Typography>
        </Grid>
        <Grid item xs='auto'>
          <DateInput
            value={shippingDateInput}
            setValue={updateShippingDate}
            maxDate={getHyphenedDate(new Date())}
          />
        </Grid>
      </Grid>
      <TransferSearchArea
        onSearchCondition={onSearchCondition}
        searchConditionInput={searchConditionInput}
        changeSearchConditionInput={changeSearchConditionInput}
      />
      <NormalTable columns={totalTransferColumn} data={totalTransferData} />
      <Grid item xs>
        <Tabs
          value={tableTabPosition}
          onChange={(_e, tabPos) => setTableTabPosition(tabPos)}>
          {regionBank.map(regionBank => (
            <Tab label={regionBank.varValue1} value={regionBank.varCd} />
          ))}
        </Tabs>
      </Grid>
      <NormalTable
        columns={transferColumn}
        data={transferData}
        pagination={{ ...pagination, handleChangePageProps }}
        paginationTop
      />
    </CompanyTitledPage>
  );
}
